<template>
  <transition name="slide-fade">
    <div id="interupt" class='interupt'>
      <div class="interupt-regular" v-if="type === 'regular'">
        <div class="back"></div>
        <div class="fun">
          <div class="fun-item fun-sun hatch"></div>
          <div class="fun-item fun-camera bigEntrance"></div>
          <div class="fun-item fun-key bigEntrance"></div>
          <div class="fun-item fun-squares hatch"></div>
          <div class="fun-item fun-crop bigEntrance"></div>
          <div class="fun-item fun-levers hatch"></div>
          <div class="fun-item fun-crown bigEntrance"></div>
        </div>
        <div class='table-content'>
          <div class="cell-content">
            <div class='the-text' v-html="interupt"></div>
            <div class='fun-butt' v-on:click="$store.commit('interupt', null)">Ok</div>
          </div>
        </div>
      </div>
      <div class="interupt-win" v-if="type === 'win'">
        <div class="back"></div>
        <div class="fun">
          <div class="fun-item fun-sun hatch"></div>
          <div class="fun-item fun-happy-green bigEntrance"></div>
          <div class="fun-item fun-crop bigEntrance"></div>
          <div class="fun-item fun-levers hatch"></div>
          <div class="fun-item fun-crown bigEntrance"></div>
          <div class="fun-item fun-happy-yellow bigEntrance"></div>
        </div>
        <div class='table-content'>
          <div class="cell-content">
            <div class='the-text' v-html="interupt"></div>
            <div class='fun-butt' v-on:click="$store.commit('interupt', null)">Ok</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'interupt',
  computed: {
    interupt () {
      let rupt = this.$store.state.interupt
      if (typeof rupt === 'string') {
        return rupt
      } else {
        return rupt.html
      }
    },
    type () {
      let rupt = this.$store.state.interupt
      if (typeof rupt === 'string') {
        return 'regular'
      } else {
        return rupt.type
      }
    }
  },
  mounted () {
    /* setTimeout(() => {
      this.$store.commit('interupt', null)
    }, 3000) */
    if (window.ga) {
      window.ga('send', 'event', 'Info popup', 'open', 'At ' + this.$route.path)
    }
  },
  components: { }
}
</script>

<style>
.interupt {
  position: fixed;
  top: 0px;
  color: #000;
  font-weight: 800;
  left: 0px;
  right: 0px;
  bottom: 0px;
  font-size: 30px;
  text-transform: uppercase;
  z-index: 9999999999;
  overflow: hidden;
}
.interupt .the-text {
  max-width: 600px;
  margin: auto;
}
.fun-butt {
  font-size: 16px;
  padding: 13px;
  border-radius: 40px;
  margin-top: 10px;
  background-color: #e6e6e6;
  border: 1px solid #d8d8d8;
  color: #272264;
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
}
.interupt .back {
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  position: absolute;
  /* background: linear-gradient(0, rgba(55, 169, 140, 1),  rgba(255, 255, 255, 0.9) 60%);
  background: linear-gradient(0, rgba(151, 215, 255, 1),  rgba(255, 255, 255, 0.8) 70%);
  */
  background-color: #fff;
  opacity: 0.94;
}
.fun {
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  position: absolute;
  z-index: 9;
}
/* h6 = small text */
.interupt h6 {
  margin: 18px 0px 10px 0px;
  font-size: 18px;
  font-weight: 100;
  text-transform: none;
}
/* h5 = points title */
.interupt h5 {
  margin: 15px 0px 10px 0px;
  font-size: 50px;
  font-weight: normal;
  text-transform: none;
  color: #79C199;
}
.fun-item {
  height: 50px;
  width: 50px;
  position: absolute;
  background-size: contain;
  background-repeat: no-repeat;
}
.fun-sun {
  top: 65%;
  left: 5%;
  height: 110px;
  width: 110px;
  background-image: url('./../assets/clipart/sun.svg');
}
.fun-key {
  top: -25px;
  right: -25px;
  height: 140px;
  width: 140px;
  background-image: url('./../assets/clipart/key.svg');
}
.fun-camera {
  top: 12%;
  left: -35px;
  height: 70px;
  width: 70px;
  transform: rotate(-3deg);
  background-image: url('./../assets/clipart/camera.svg');
}
.fun-squares {
  top: 50%;
  right: -20px;
  height: 70px;
  width: 70px;  
  background-image: url('./../assets/clipart/squares.svg');
}
.fun-happy-yellow {
  top: 50%;
  right: -20px;
  height: 70px;
  width: 70px;  
  transform: rotate(3deg);
  background-image: url('./../assets/clipart/happy_yellow.svg');
}
.fun-happy-green {
  top: 1%;
  right: -10px;
  height: 150px;
  width: 150px;
  transform: rotate(-5deg);
  background-image: url('./../assets/clipart/happy_green.svg');
}
.fun-crop {
  bottom: 20%;
  right: 10%;
    height: 50px;
    width: 50px;  
  background-image: url('./../assets/clipart/crop.svg');
}
.fun-levers {
  bottom: 2%;
  right: 30%;
  height: 60px;
  width: 60px;
  background-image: url('./../assets/clipart/test.svg');
}
.fun-crown {
  top: 20%;
  left: 30%;
  height: 70px;
  width: 70px;  
  background-image: url('./../assets/clipart/crown.svg');
}
.interupt-win .fun-crown {
  height: 90px;
  width: 90px; 
  top: 15%;
  left: 12%;  
}
.interupt .table-content {
  display: table;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  height: 100%;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  z-index: 10;
}
.interupt .cell-content {
  text-align: center;
  vertical-align: middle;
  display: table-cell;
  padding: 50px;
}
.rand-enter-active {
  animation: bounce-in .5s;
}
.rand-leave-active {
  animation: bounce-in .5s reverse;
}
.rand-enter, .rand-leave-to {
  transform: translateY(90px) rotate(90deg) ;
  opacity: 0;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

.bigEntrance{
  animation-name: bigEntrance;
  -webkit-animation-name: bigEntrance;  

  animation-duration: 1.6s; 
  -webkit-animation-duration: 1.6s;

  animation-timing-function: ease-out;  
  -webkit-animation-timing-function: ease-out;  

  visibility: visible !important;     
}

@keyframes bigEntrance {
  0% {
    transform: scale(0.3) rotate(6deg) translateX(-30%) translateY(30%);
    opacity: 0.2;
  }
  30% {
    transform: scale(1.03) rotate(-2deg) translateX(2%) translateY(-2%);    
    opacity: 1;
  }
  45% {
    transform: scale(0.98) rotate(1deg) translateX(0%) translateY(0%);
    opacity: 1;
  }
  60% {
    transform: scale(1.01) rotate(-1deg) translateX(0%) translateY(0%);   
    opacity: 1;
  } 
  75% {
    transform: scale(0.99) rotate(1deg) translateX(0%) translateY(0%);
    opacity: 1;
  }
  90% {
    transform: scale(1.01) rotate(0deg) translateX(0%) translateY(0%);    
    opacity: 1;
  } 
  100% {
    transform: scale(1) rotate(0deg) translateX(0%) translateY(0%);
    opacity: 1;
  }   
}

@-webkit-keyframes bigEntrance {
  0% {
    -webkit-transform: scale(0.2) rotate(6deg) translateX(-50%) translateY(50%);
    opacity: 0.2;
  }
  30% {
    -webkit-transform: scale(1.03) rotate(-2deg) translateX(2%) translateY(-2%);    
    opacity: 1;
  }
  45% {
    -webkit-transform: scale(0.98) rotate(1deg) translateX(0%) translateY(0%);
    opacity: 1;
  }
  60% {
    -webkit-transform: scale(1.01) rotate(-1deg) translateX(0%) translateY(0%);   
    opacity: 1;
  } 
  75% {
    -webkit-transform: scale(0.99) rotate(1deg) translateX(0%) translateY(0%);
    opacity: 1;
  }
  90% {
    -webkit-transform: scale(1.01) rotate(0deg) translateX(0%) translateY(0%);    
    opacity: 1;
  } 
  100% {
    -webkit-transform: scale(1) rotate(0deg) translateX(0%) translateY(0%);
    opacity: 1;
  }       
}

.hatch{
  animation-name: hatch;
  -webkit-animation-name: hatch;  

  animation-duration: 2s; 
  -webkit-animation-duration: 2s;

  animation-timing-function: ease-in-out; 
  -webkit-animation-timing-function: ease-in-out;

  transform-origin: 50% 100%;
  -ms-transform-origin: 50% 100%;
  -webkit-transform-origin: 50% 100%; 

  visibility: visible !important;   
}

@keyframes hatch {
  0% {
    transform: rotate(0deg) scaleY(0.4);
  }
  20% {
    transform: rotate(-3deg) scaleY(1.15);
  }
  35% {
    transform: rotate(3deg) scaleY(1);
  }
  50% {
    transform: rotate(-3deg);
  } 
  65% {
    transform: rotate(1.5deg);
  } 
  80% {
    transform: rotate(-1.5deg);
  }   
  100% {
    transform: rotate(0deg);
  }                 
}

@-webkit-keyframes hatch {
  0% {
    -webkit-transform: rotate(0deg) scaleY(0.4);
  }
  20% {
    -webkit-transform: rotate(-3deg) scaleY(1.15);
  }
  35% {
    -webkit-transform: rotate(3deg) scaleY(1);
  }
  50% {
    -webkit-transform: rotate(-3deg);
  } 
  65% {
    -webkit-transform: rotate(1.5deg);
  } 
  80% {
    -webkit-transform: rotate(-1.5deg);
  }   
  100% {
    -webkit-transform: rotate(0deg);
  }   
}
</style>



// WEBPACK FOOTER //
// Interupt.vue?49cbc8c6